import type { Player } from '../player';
import type { Enemy } from '../enemies';
import type { BulletPool } from '../bullets';

interface AddonResult {
  missileTier: number;
  ringActive: boolean;
}

// Auto-fire addons that activate at weapon tiers: homing missiles every ~interval, then
// 360° ring bursts every 2s once weaponIdx ≥ 24. Owns its own timers internally.
export class WeaponAddons {
  private missileTimer = 0;
  private ringTimer = 0;

  tick(dt: number, weaponIdx: number, alive: boolean, player: Player, enemies: Enemy[], bullets: BulletPool): AddonResult {
    const missileTier = Math.max(0, Math.floor((weaponIdx + 1 - 5) / 4) + (weaponIdx + 1 >= 5 ? 1 : 0));
    if (missileTier > 0 && alive) {
      this.missileTimer += dt;
      const interval = Math.max(0.4, 1.6 - missileTier * 0.15);
      if (this.missileTimer >= interval) {
        this.missileTimer = 0;
        for (let i = 0; i < missileTier; i++) {
          let target: { x: number; y: number } | null = null;
          let bestD = Infinity;
          for (const en of enemies) {
            if (!en.alive || en.kind === 'asteroid') continue;
            const d = (en.x - player.x) ** 2 + (en.y - player.y) ** 2;
            if (d < bestD) { bestD = d; target = en; }
          }
          if (target) {
            const a = Math.atan2(target.y - player.y, target.x - player.x) + (i - missileTier / 2) * 0.2;
            bullets.spawn({
              x: player.x, y: player.y,
              vx: Math.cos(a) * 600, vy: Math.sin(a) * 600,
              dmg: 18, r: 4, color: 0xffaa00,
            });
          }
        }
      }
    }
    const ringActive = weaponIdx + 1 >= 25;
    if (ringActive && alive) {
      this.ringTimer += dt;
      if (this.ringTimer >= 2.0) {
        this.ringTimer = 0;
        const ringShots = 8 + Math.min(16, Math.floor((weaponIdx + 1 - 25) / 3));
        for (let i = 0; i < ringShots; i++) {
          const a = (i / ringShots) * Math.PI * 2;
          bullets.spawn({
            x: player.x, y: player.y,
            vx: Math.cos(a) * 700, vy: Math.sin(a) * 700,
            dmg: 14, r: 3, color: 0x44ddff,
          });
        }
      }
    }
    return { missileTier, ringActive };
  }
}
